<template>
  <div class="align">
    <div class="timeout">
      <img src="../assets/pngs/boomy-sad.png" />
      <h3>We could not load this page... please try again</h3>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.align {
  display: flex;
  align-items: center;
  min-height: 24em;
  justify-content: center;
  text-align: center;
}

.align .timeout {
  flex: 1;
}
</style>
